const { SEO_LANDING_PAGES } = require('./landingPageData');

const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

const SEO_LANDING_PAGE_BY_PATH = SEO_LANDING_PAGES.reduce((acc, page) => {
  acc[page.path] = page;
  return acc;
}, {});

function normalizeLandingPath(pathname = '') {
  const cleanPath = pathname.split('?')[0].split('#')[0].replace(/\/+$/, '');
  return cleanPath || '/';
}

function getSeoLandingPageByPath(pathname) {
  return SEO_LANDING_PAGE_BY_PATH[normalizeLandingPath(pathname)] || null;
}

function getSeoLandingPageRoutes(landingPage) {
  return [landingPage.path, `${landingPage.path}/`];
}

function getSeoLandingPageCanonicalUrl(siteUrl, landingPage) {
  return `${siteUrl.replace(/\/+$/, '')}${landingPage.path}`;
}

function getSeoLandingPageOpenGraphImageUrl(siteUrl, landingPage) {
  const imagePath = landingPage.ogImage || '/og-image.jpg';

  if (ABSOLUTE_URL_PATTERN.test(imagePath)) {
    return imagePath;
  }

  return `${siteUrl.replace(/\/+$/, '')}${imagePath.startsWith('/') ? imagePath : `/${imagePath}`}`;
}

function getSeoLandingPageBreadcrumbs(landingPage) {
  if (!landingPage) {
    return [];
  }

  return [
    { name: 'Inici', path: '/' },
    { name: landingPage.heading, path: landingPage.path },
  ];
}

function getSeoLandingPageMeta(landingPage, siteUrl = 'https://fesmelacta.cat') {
  return Object.assign({}, landingPage, {
    lang: 'ca',
    ogImage: getSeoLandingPageOpenGraphImageUrl(siteUrl, landingPage),
    ogImageAlt: landingPage.ogImageAlt || landingPage.heading || landingPage.title,
  });
}

module.exports = {
  SEO_LANDING_PAGES,
  SEO_LANDING_PAGE_BY_PATH,
  getSeoLandingPageBreadcrumbs,
  getSeoLandingPageByPath,
  getSeoLandingPageCanonicalUrl,
  getSeoLandingPageOpenGraphImageUrl,
  getSeoLandingPageMeta,
  getSeoLandingPageRoutes,
  normalizeLandingPath,
};
